
import packageInfo from '../../package.json';
// environment.base.ts
export const baseEnvironment = {
    version: packageInfo.version,
    copyright: 'Bakelor RTLS Navizard Copyright Reserved',
    enableSwInDev: false,
    landingPerformanceMode: 'adaptive',
    landingPerfTelemetry: true,
    bootLoaderGate: {
        enabled: false,
        maxWaitMs: 1500
    },
  
  delk: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjcxMzJkZWI2LTc3N2QtNDU5MS1hYjcwLWUyZDAyOTgxM2IxMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.A2UjVbYlET4UVUXbvi9JugBv4ddPteB8jqj05T4bg5VYo4Bc7gVUkWC+zq/z8ttGR3jQTGvEIzpawUCNVIJmhyXbx5KWe3xB8MA6WdQOCI19SbJ2VVp3kHTlAayf1QSf3HHFgQ==',

    firebaseConfig: {
      apiKey: "AIzaSyB-UJhrysgoDFPYh7Tdui-AVQfMGXseCqw",
      authDomain: "ab-rtls-pn.firebaseapp.com",
      projectId: "ab-rtls-pn",
      storageBucket: "ab-rtls-pn.appspot.com",
      messagingSenderId: "921218140601",
      appId: "1:921218140601:web:9911ffbedef0322b79ce68"
    }
  };
  
